import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import React from 'react';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { useAutomationSuggestionsContext } from '../../Context';

export default function useActionButton(automationSuggestionVariant) {
  const { displayErrorMessage, displaySuccess } = useSnackbarContext();
  const { refreshAutomationSuggestionsCollection } = useAutomationSuggestionsContext();
  const { refreshPageContentCollection } = usePageContentContext();
  const [confirmShowing, setShowConfirm] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const onConfirmDelete = async () => {
    setLoading(true);
    try {
      await automationSuggestionVariant.delete();
      await refreshAutomationSuggestionsCollection();
      displaySuccess('Automation reverted.');
    } catch (err) {
      displayErrorMessage(err, err.errors);
    }
    setShowConfirm(false);
    setLoading(false);
    refreshPageContentCollection();
  };

  const onRunAutomation = async () => {
    setLoading(true);
    try {
      await automationSuggestionVariant.link('self').post();
      await refreshAutomationSuggestionsCollection();
      displaySuccess('Automation ran successfully.');
    } catch (err) {
      displayErrorMessage(err, err.errors);
    }
    setShowConfirm(false);
    setLoading(false);
    refreshPageContentCollection();
  };

  return {
    showConfirm: confirmShowing,
    onCancel: () => setShowConfirm(false),
    onConfirmDelete,
    onRevertAutomation: () => setShowConfirm(true),
    isLoading: loading,
    onRunAutomation,
  };
}
